import {RatingBarColor, RatingBarSize, RatingBarType} from '../model/feedback-info';
import {PlaybackQuality, TourVideoType} from '../model/tour';
import {AspectRatio, ImageSize} from '../model/image';
import {SurveyQueryPage, SurveyQuerySortDirection, SurveyQuerySortField} from '../model/survey-query';
import {ToggleableFields} from '../model/survey';
import {QueryPage} from '../model/product-review-query';
export enum SocialWidget {
  Icons,
  Menu
}

export function EnumAware(constructor: Function) {
  constructor.prototype.RatingBarType = RatingBarType;
  constructor.prototype.RatingBarColor = RatingBarColor;
  constructor.prototype.RatingBarSize = RatingBarSize;
  constructor.prototype.PlaybackQuality = PlaybackQuality;
  constructor.prototype.TourVideoType = TourVideoType;
  constructor.prototype.ImageSize = ImageSize;
  constructor.prototype.AspectRatio = AspectRatio;
  constructor.prototype.SocialWidget = SocialWidget;
  constructor.prototype.SurveyQuerySortField = SurveyQuerySortField;
  constructor.prototype.SurveyQuerySortDirection = SurveyQuerySortDirection;
  constructor.prototype.SurveyQueryPage = SurveyQueryPage;
  constructor.prototype.ToggleableFields = ToggleableFields;
  constructor.prototype.QueryPage = QueryPage;
}



// WEBPACK FOOTER //
// ./src/app/decorators/enum-aware.decorator.ts